import { render } from "./보건관리위탁절차.vue?vue&type=template&id=64c20e96"
import script from "./보건관리위탁절차.vue?vue&type=script&lang=js"
export * from "./보건관리위탁절차.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__